export default "__VITE_ASSET__4341f2cf__"